import { bridgeDescriptor } from '@cardforest/games/games/bridge/descriptor.js';
import { SuitGlyph } from '../discovery/cards.js';
import type { GameDiscoveryPresentation } from '../discovery/types.js';

export const bridgeDiscoveryPresentation = {
  gameId: bridgeDescriptor.gameId,
  Icon: ({ className }) => <SuitGlyph suit="spades" className={className} />,
  Thumbnail: () => (
    <div
      aria-hidden="true"
      className="relative flex h-14 w-16 shrink-0 flex-col items-center justify-center gap-1 rounded-xl border border-border/80 bg-muted/40 p-1.5"
    >
      <div className="grid grid-cols-2 gap-1">
        <SuitGlyph suit="spades" className="size-3" />
        <SuitGlyph suit="hearts" className="size-3" />
        <SuitGlyph suit="diamonds" className="size-3" />
        <SuitGlyph suit="clubs" className="size-3" />
      </div>
      <span className="rounded bg-background px-1.5 py-0.5 text-[9px] leading-none font-bold tracking-tight text-foreground border border-border shadow-2xs">
        3NT
      </span>
    </div>
  ),
} satisfies GameDiscoveryPresentation;
